<template>
    <v-data-table
        :headers="headers"
        :items="$page.props.categories"
    >
        <template v-slot:top>
            <v-toolbar
                flat
            >
                <v-toolbar-title>Product Categories</v-toolbar-title>
                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-dialog
                    v-model="dialog"
                    max-width="500px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="primary"
                            dark
                            class="mb-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            New Category
                        </v-btn>
                    </template>
                    <v-form @submit.prevent="save">
                        <v-card>
                            <v-card-title class="mb-5">
                                <span class="text-h5">{{ formTitle }}</span>
                            </v-card-title>

                            <v-card-text>
                                <v-text-field
                                    v-model="form.title"
                                    label="Category Title"
                                    outlined
                                />
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="blue darken-1"
                                    text
                                    @click="close"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    color="primary"
                                    depressed
                                    type="submit"
                                    :loading="form.processing"
                                >
                                    Save Details
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>
            </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">

            <v-btn icon  @click="editItem(item)" color="primary">
                <v-icon  class="mx-2" >
                    mdi-pencil
                </v-icon>
            </v-btn>
            <v-btn icon  @click="deleteItem(item)" color="error">
                <v-icon  class="mx-2" >
                    mdi-delete
                </v-icon>
            </v-btn>
        </template>

        <template v-slot:item.products="{ item }">
            {{ item.products_count }}
        </template>
    </v-data-table>
</template>

<script>
import AdminLayout from "../AdminLayout";

export default {
    layout:AdminLayout,
    data(){
        return{
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Title', value: 'title' },
                { text: 'Slug', value: 'slug' },
                { text: 'Products', value: 'products' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            desserts: [],
            editedIndex: -1,

            form:this.$inertia.form( {
                id: '',
                title: '',
            }),
        }
    },

    computed: {
        formTitle () {
            return this.editedIndex === -1 ? 'New Category' : 'Edit Category'
        },
    },

    watch: {
        dialog (val) {
            val || this.close()
        },
        dialogDelete (val) {
            val || this.closeDelete()
        },
    },


    methods: {

        editItem (item) {
            this.editedIndex  = 1
            this.form.id      = item.id
            this.form.title   = item.title
            this.dialog       = true
        },

        deleteItem (item) {
            this.editedIndex = this.desserts.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },
        close () {
            this.dialog = false
            this.form.reset()
        },

        save () {
            this.form.post(route('admin.categories.store'),{
                onSuccess:()=>{
                    this.close()
                }
            })
        },
    },
}
</script>
